// Lazy load function
const lazyLoad = (file) => () => import(/* webpackChunkName: "[request]" */ `@/views/production/timesheet/${file}.vue`);

export default [
    {
        path: "/timesheet",
        name: "timesheet",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "Timesheet",
        },
        components: {
            content: lazyLoad("timesheet-list"),
        },
    },
];
